module.exports = __webpack_public_path__ + "static/media/legs.c9441c06.jpg";